import { Store } from 'vuex'
import { createStore as createVueStore } from 'vuex-extensions'
import main from '@/store/modules/main'
import catalog from '@/store/modules/catalog'
import auth from '@/store/modules/auth'
import articles from '@/store/modules/articles'
import files from '@/store/modules/files'
import basket from '@/store/modules/basket'
import users from '@/store/modules/users'
import support from '@/store/modules/support'
import reporting from '@/store/modules/reporting'
import documents from '@/store/modules/documents'
import invoicesOlsa from '@/store/modules/invoicesOlsa'
import contracts from '@/store/modules/contracts'
import estratto from '@/store/modules/estratto'
import { ICatalogState } from '@/store/modules/catalog/interfaces/ICatalogState'
import { IAuthState } from '@/store/modules/auth/IAuthState'
import { IMainState } from '@/store/modules/main/intefaces/IMainState'
import { IArticlesState } from '@/store/modules/articles/interfaces/IArticlesState'
import { IEstrattoState } from '@/store/modules/estratto/interfaces/IEstrattoState'
import orders, { IOrdersState } from './modules/orders'
import common, { ICommonState } from './modules/common'
import links from './modules/links'
import tickets from './modules/tickets'
import helpPages from './modules/help-pages'
import pageContents from './modules/page-contents'
import { IBasketState } from './modules/basket/interfaces/IBasketState'
import { IUsersState } from '@/store/modules/users/interfaces/IUsersState'
import { IFilesState } from '@/store/modules/files/interfaces/IFilesState'
import { ISupportState } from '@/store/modules/support/interfaces/ISupportState'
import { IReportingState } from '@/store/modules/reporting/interfaces/IReportingState'
import { IPortalHardCodeLinkState, IPortalPageMenuLinkState } from '@/store/modules/links/interfaces'
import { IHelpPagesState } from './modules/help-pages/interfaces'
import { IDocumentsState } from '@/store/modules/documents/interfaces/IDocumenstState'
import { IInvoicesOlsaState } from './modules/invoicesOlsa/interfaces/IInvoicesOlsaState'
import { IContractsState } from './modules/contracts/interfaces/IContractsState'
import { ITicketsState } from '@/store/modules/tickets/interfaces/ITicketsState'
import { IPageContentsState } from './modules/page-contents/interfaces'
import { IBecomeSustainableState } from '@/store/modules/becomeSustainable/interfaces/IBecomeSustainableState'
import becomeSustainable from '@/store/modules/becomeSustainable'
import localStorageCache from '@/utils/localStorageCache'
import CacheKeys from '@/utils/CacheKeys'
import brands from '@/store/modules/brands'
import { IBrandsState } from '@/store/modules/brands/interfaces/IBrandsState'
export interface IRootState {
  main: IMainState
  catalog: ICatalogState
  auth: IAuthState
  orders: IOrdersState
  articles: IArticlesState
  brands: IBrandsState
  files: IFilesState
  common: ICommonState
  basket: IBasketState
  users: IUsersState
  support: ISupportState
  reporting: IReportingState
  links: IPortalHardCodeLinkState & IPortalPageMenuLinkState
  tickets: ITicketsState
  helpPages: IHelpPagesState,
  pageContents: IPageContentsState,
  documents: IDocumentsState
  invoicesOlsa: IInvoicesOlsaState
  contracts: IContractsState
  estratto: IEstrattoState
  becomeSustainable: IBecomeSustainableState
}

export default function createStore (cache: any): Store<IRootState> {
  const options = {
    modules: {
      main,
      catalog,
      orders,
      auth,
      brands,
      articles,
      files,
      common,
      basket,
      users,
      support,
      reporting,
      links,
      tickets,
      helpPages,
      pageContents,
      documents,
      invoicesOlsa,
      contracts,
      estratto,
      becomeSustainable
    },
    getters: {
      getCache (): any {
        return cache
      }
    },
    actions: {
      async logout () {
        const lastStore = localStorage.getItem('store') as string
        const lastLang = localStorage.getItem('lang') as string
        const sawTutorials = localStorage.getItem('sawTutorials')
        const publicArticles = await localStorageCache.methods.getCache(CacheKeys.CACHE_ARTICLES_PUBLIC_KEY)
        const publicArticlesEn = await localStorageCache.methods.getCache(CacheKeys.CACHE_ARTICLES_PUBLIC_KEY_EN)
        const publicBanner = await localStorageCache.methods.getCache(CacheKeys.CACHE_BANNER_PUBLIC)
        localStorage.clear()
        localStorage.removeItem('isFirstAddToCart')

        /* clear session */
        sessionStorage.clear()

        /* remove cookies */
        const dateTime = new Date()
        dateTime.setTime(dateTime.getTime())
        const expires = 'expires=' + dateTime.toUTCString()
        document.cookie = 'gmid' + '=' + '' + ';domain=gigya.com;path=/;' + expires
        document.cookie = 'hasGmid' + '=' + '' + ';domain=gigya.com;path=/;' + expires
        document.cookie = 'ucid' + '=' + '' + ';domain=gigya.com;path=/;' + expires
        document.cookie = 'private_content_version' + '=' + '' + ';domain=prazdrojonline.cz;path=/;' + expires
        document.cookie = '_ga' + '=' + '' + ';domain=prazdrojonline.cz;path=/;' + expires

        localStorage.setItem('store', lastStore)
        localStorage.setItem('lang', lastLang)
        publicArticles && localStorageCache.methods.setCache(CacheKeys.CACHE_ARTICLES_PUBLIC_KEY, publicArticles)
        publicArticlesEn && localStorageCache.methods.setCache(CacheKeys.CACHE_ARTICLES_PUBLIC_KEY_EN, publicArticlesEn)
        publicBanner && localStorageCache.methods.setCache(CacheKeys.CACHE_BANNER_PUBLIC, publicBanner)
        if (sawTutorials) {
          localStorage.setItem('sawTutorials', sawTutorials)
        }
      }
    }
  }

  return createVueStore(Store, options)
}
